import { Component, Injector, OnInit, Input } from '@angular/core';
import { UnsupportedCase } from '../../../../classes/UnsupportedUseCases';

import { BaseFormComponent } from '../base-form.component';
import { ModalType } from '../../../../../js/interfaces/CoverpathTypes';
import { ApplicationSectionsList } from '../../../../classes/ApplicationSection';
import type { CoverpathPolicy } from '../../../../../classes/coverpath_subclasses/CoverpathPolicy';
import { SubjectManager } from '../../../../../../common/js/subjectManager/SubjectManager';

@Component({
  moduleId: module.id,
  selector: 'product-switch-button',
  templateUrl: './product-switch-button.component.html',
})
export class ProductSwitchButtonComponent extends BaseFormComponent {
  productType;
  constructor(protected injector: Injector) {
    super(injector);
    this.productType = this.appState.controller.customer.application.primaryPolicy.productType;
  }

  async showProductSwitchModal() {
    const controller = this.appState.controller;
    const primaryPolicy: CoverpathPolicy = controller.customer.application.primaryPolicy as CoverpathPolicy;
    const modalType = {
      type: ModalType.productSwitch,
      modalData: {
        productType: primaryPolicy.productType,
      },
    };
    this.modalService.activate(modalType);
    const subscription = this.modalService.userResponse.subscribe(async (dialogResponse) => {
      subscription.unsubscribe();
      if (dialogResponse) {
        switch (dialogResponse['action']) {
          case 'Switch to Term':
            primaryPolicy.setDefaultInAppTermPolicy();
            break;
          case 'Switch to Whole':
            primaryPolicy.setDefaultInAppWholeLifePolicy();
            break;
          default:
            break;
        }
        await this.appSvc.updateAssociatedProperties('customer.application.primaryPolicy.termDisplay', '');
        SubjectManager.publish('update_faceterm');
        this.productType = primaryPolicy.productType;
        this.updateProgressAndSubscriptions();
      }
    });
  }

  updateFromModel(): void {}
}
